module.exports = __webpack_public_path__ + "assets/img/bottom-bg.1222ee65.png";